import {
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  _COLORS,
  _GESTION_VIAGERE,
  _VIAGER_MIXTE,
} from "../../../utils/_constants";
import { _STYLES } from "../../../utils/_style_constants";
import { editInstantRequest } from "../../../utils/formHelper";
import { NumericFormat } from "react-number-format";
import MouseOverPopover from "../MouseOverPopover";
import HelpIcon from "@mui/icons-material/Help";

const RemunerationAgence = ({
  currentMandat,
  setCurrentMandat,
  refresh,
  register,
  disabledSign = false,
}) => {
  const field =
    currentMandat?.typeVente?.nom === _VIAGER_MIXTE
      ? "occupé"
      : currentMandat?.typeVente?.nom !== _GESTION_VIAGERE
      ? "libre"
      : "occupée";

  return (
    <>
      <Grid container columnSpacing={1} rowSpacing={4} padding={4}>
        <Grid item xs={3} md={2} alignItems={"center"} display={"flex"}>
          <Typography
            sx={{
              ..._STYLES.typographyLabelTitle,
              ...{ color: _COLORS.primary },
            }}
          >
            Honoraire agence charge*
          </Typography>{" "}
          <MouseOverPopover
            sx={{
              marginLeft: "10px",
              width: "350px",
            }}
            title={<HelpIcon />}
            popoverText="Charge vendeur ou acquéreur + montant TTC des honoraires agence si charge acquéreur"
          />
        </Grid>
        <Grid item xs={6} md={3} display={"flex"} gap={1} alignItems={"center"}>
          <NumericFormat
            thousandSeparator=" "
            allowNegative={false}
            customInput={TextField}
            decimalScale={2}
            displayType="input"
            allowedDecimalSeparators={["."]}
            id="charge"
            size="small"
            fullWidth
            disabled={disabledSign}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">€ TTC</InputAdornment>
              ),
            }}
            value={currentMandat?.charge ? currentMandat?.charge : ""}
            {...register("charge", {
              onChange: (e) => {
                setCurrentMandat({
                  ...currentMandat,
                  charge: e.target.value.replace(/ /g, ""),
                });
              },
              onBlur: (e) => {
                let m = editInstantRequest(
                  parseFloat(e.target.value.replace(/ /g, "")),
                  currentMandat["@id"],
                  "charge",
                );

                m.then((m) => {
                  if (m["@context"] === "/api/contexts/Error") {
                    refresh();
                  } else {
                    setCurrentMandat(m);
                  }
                });
              },
            })}
          />
        </Grid>
        <Grid item xs={3} md={7} alignItems={"center"} display={"flex"}>
          <Grid item xs={2} md={3}>
            <Typography>A la charge*</Typography>
          </Grid>
          <Grid item xs={10} md={3}>

            <Select
              label="A la charge de"
              size="small"
              fullWidth
              disabled={disabledSign}
              value={
                field === "libre"
                  ? currentMandat?.remunerationPayeur
                    ? currentMandat?.remunerationPayeur
                    : ""
                  : currentMandat?.remunerationPayeurOccupe
                  ? currentMandat?.remunerationPayeurOccupe
                  : ""
              }
              id={
                field === "libre"
                  ? "remunerationPayeur"
                  : "remunerationPayeurOccupe"
              }
              onChange={(e) => {
                let m = editInstantRequest(
                  e.target.value,
                  currentMandat["@id"],
                  field === "libre"
                    ? "remunerationPayeur"
                    : "remunerationPayeurOccupe",
                );

                m.then((m) => {
                  if (m["@context"] === "/api/contexts/Error") {
                    refresh();
                  } else {
                    setCurrentMandat(m);
                  }
                });
              }}
            >
              <MenuItem value="vendeur"> Du vendeur</MenuItem>
              <MenuItem value="acquereur"> De l'acquéreur</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default RemunerationAgence;
